import React, { useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import { Form, Radio, Space, Switch, Table } from "antd";
import numeral from "numeral";

import capitalizeFirst from "../../utils/capitalizeFirst";

const shorterText = (string) => {
  return `${string.slice(0, 30)}...`;
};

const columns = [
  {
    title: "Cliente",
    dataIndex: "EntityName",
    render: (_, record) => {
      return capitalizeFirst(shorterText(record.EntityName));
    },
  },
  {
    title: "Total",
    dataIndex: "TotalAmount",
    render: (_, record) => {
      return `${numeral(record.TotalAmount).format("$0,00")}`;
    },
  },
];

const ListClientes = (props) => {
  return (
    <Table
      columns={columns}
      dataSource={props.clientes}
      size="small"
      rowKey="Id"
    />
  );
};

export default ListClientes;
